import { Injectable } from '@angular/core';
import { HttpClient } from "@angular/common/http";
import { Observable } from "rxjs";
import { Configuration } from 'src/assets/Configuration';
import { MyCompetenceTrainingModel } from '../models/training/my-competence-training.model';

@Injectable({
    providedIn: 'root'
})
export class MyCompetenceService {

    constructor(private httpClient: HttpClient) {
    }

    public getMyCompetenceTraining(category: string): Observable<MyCompetenceTrainingModel> {
        return this.httpClient.get<MyCompetenceTrainingModel>(
            Configuration.getApiBaseUrl() + '/MyCompetence/' + category
        );
    }
}